import { createFileRoute } from "@tanstack/react-router";
import { MultilingualServiceLanding } from "@/components/MultilingualServiceLanding";
import { ZH_SERVICES } from "@/data/zh-service-content";
import { SEO_SITE, multiHreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const PATH = "/zh/services";
const C = ZH_SERVICES;

export const Route = createFileRoute("/zh/services")({
  head: () => ({
    meta: [
      { title: ctaTitle("曼谷一站式中文法律服务 — 公证 · 翻译 · 签证 | NYC Legal", "/zh/services", "th")},
      { name: "description", content: ctaDesc("曼谷一站式中文法律服务:公证 · 翻译 · 海牙认证 · 跨国婚姻 · 签证 · 工作证 · 公司设立 · 税务。15+ 年经验,中文专员接待。. Free consultation — message us and get a same-day answer.", "/zh/services", "th")},
      { property: "og:title", content: ctaTitle("曼谷一站式中文法律服务 | NYC Legal", "/zh/services", "th")},
      { property: "og:description", content: ctaDesc("在泰中国人 / 企业 / 留学生全程中文服务。", "/zh/services", "th")},
      { property: "og:url", content: `${SEO_SITE}${PATH}` },
      { property: "og:locale", content: "zh_CN" },
    ],
    links: [
      { rel: "canonical", href: `${SEO_SITE}${PATH}` },
      ...multiHreflangLinks(
        [
          { hreflang: "th-TH", path: "/services" },
          { hreflang: "en", path: "/en/services" },
          { hreflang: "zh", path: "/zh/services" },
          { hreflang: "x-default", path: "/services" },
        ],
        "/services",
      ),
    ],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "LegalService",
          name: "NYC Legal & Notary — 中文服务",
          url: `${SEO_SITE}${PATH}`,
          areaServed: "TH",
          inLanguage: "zh",
          priceRange: "฿500–฿50,000",
          serviceType: "Legal · Notary · Translation · Visa · Company Setup",
          provider: { "@type": "LegalService", name: "NYC Language Institute", url: SEO_SITE },
        }),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          inLanguage: "zh",
          mainEntity: C.faqs.map((f) => ({
            "@type": "Question",
            name: f.q,
            acceptedAnswer: { "@type": "Answer", text: f.a },
          })),
        }),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            { "@type": "ListItem", position: 1, name: "首页", item: `${SEO_SITE}/zh` },
            { "@type": "ListItem", position: 2, name: "服务", item: `${SEO_SITE}${PATH}` },
          ],
        }),
      },
    ],
  }),
  component: () => <MultilingualServiceLanding c={C} />,
});
